export enum EstatesApiPath {
  GET_ESTATES = 'irent/Estates',
  GET_MY_ESTATES = 'irent/Estates/my',
  GET_ADMIN_ESTATES = 'irent/admin/estate',
}
